/*
 * Copyright (c) 2023
 * 
 * Created Date: Monday, July 24th 2023, 3:06:44 pm
 * Author: 🫰Aris Bimas Nugroho
 * 
 */
import { Button } from 'antd'
import React from 'react'
import { FilterFilled } from '@ant-design/icons';

export const ButtonAdvanceFilter = (props) => {
  return (
    <div className='wrap-advance-filter'>
      <Button {...props} icon={< FilterFilled />} className='mb-1' > Advance filter</Button >
    </div >
  )
}
